<template>
    <div>
        <div style="text-align: center;">
            <zm-radio-group v-model="selectedDescribe" buttonStyle @change="onChange">
                <zm-radio label="Topic"></zm-radio>
                <zm-radio label="Group"></zm-radio>
            </zm-radio-group>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name: 'describe',
    data () {
        return {
            id: '',
            selectedDescribe: ''
        }
    },
    created () {
        this.id = this.$route.params.id
        this.selectedDescribe = 'Topic'
        this.$router.push('/dashboard/channel/describe/' + this.id + '/topic')
    },
    methods: {
        onChange (val) {
            if (val === 'Topic') {
                this.$router.push('/dashboard/channel/describe/' + this.id + '/topic')
            } else if (val === 'Group') {
                this.$router.push('/dashboard/channel/describe/' + this.id + '/group')
            } else {
            }
        }
    }
}
</script>
<style>
.zm-radio-group--small[buttonstyle] .zm-radio .zm-radio__label {
    line-height: 16px;
}
</style>
